import React from "react";
import styled, { keyframes, css } from "styled-components";
import { useNavigate } from "react-router-dom";
import SuccessImg from "../common/image/game/성공.png";
import FailImg from "../common/image/game/실패.png";
import { isMobile } from "../common/style";

type ResultType = {
  result: boolean;
  time: number;
};

const ResultPage: React.FC<ResultType> = ({ result, time }) => {
  const navigate = useNavigate();

  return (
    <>
      {result ? (
        <TimeBtnDiv timeani={time === 0 ? 1 : 0}>
          <img src={SuccessImg} alt="성공" />
          <BtnDiv>
            <h2>성공</h2>
            <button onClick={() => navigate("/")}>또 하기</button>
          </BtnDiv>
        </TimeBtnDiv>
      ) : (
        <TimeBtnDiv timeani={time === 0 ? 1 : 0}>
          <img src={FailImg} alt="실패" />
          <BtnDiv>
            <h2>실패</h2>
            <button onClick={() => navigate("/")}>재도전</button>
          </BtnDiv>
        </TimeBtnDiv>
      )}
    </>
  );
};

export default ResultPage;

const bigAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2) translateY(-10%);
  }
`;

const TimeBtnDiv = styled.div<{ timeani: number }>`
  position: relative;
  top: 10%;

  img {
    width: 294px;
    animation: ${({ timeani }) =>
      timeani
        ? css`
            ${bigAnimation} 1.5s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      width: 180px;
    }
  }
`;

const BtnDiv = styled.div`
  display: flex;

  ${isMobile} {
    flex-direction: column;
  }

  h2 {
    margin-left: 230px;
    color: #d48f8f;
    font-family: GmarketSansBold;
    font-size: 50px;
    font-weight: 700;

    ${isMobile} {
      margin-top: 5px;
      margin-left: 0px;
      font-size: 40px;
    }
  }

  button {
    margin-top: -20px;
    margin-left: 65px;
    width: 170px;
    height: 80px;
    border-radius: 100px;
    border: 3px solid #edb4b4;
    background: #fff;

    color: #d48f8f;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 27px;
    font-weight: 700;

    cursor: pointer;

    &:hover {
      background: #ffeaea;
    }

    ${isMobile} {
      margin-top: 8px;
      margin-left: 5px;
      width: 170px;
      height: 65px;
      border: 2px solid #edb4b4;
      font-size: 22px;
    }
  }
`;
